// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
// Views
import SuncoCreate from "views/Integrations/application/channels/Sunco/create";
import SuncoEdit from "views/Integrations/application/channels/Sunco/edit";
import SuncoView from "views/Integrations/application/channels/Sunco/view";

import SuncoCampaignsCreate from "views/Integrations/application/channels/SuncoCampaigns/create";
import SuncoCampaignsEdit from "views/Integrations/application/channels/SuncoCampaigns/edit";
import SuncoCampaignsView from "views/Integrations/application/channels/SuncoCampaigns/view";

import IntegrationsDirectory from "views/Integrations/application/directory";
// Styles
import "views/Integrations/styles/index.scss";

class RouteIntegrations extends Component {
    setContentView = (channel) => {
        switch (channel) {
            case "sunco" :
                return <SuncoView/>;
            case "sunco_campaigns":
                return <SuncoCampaignsView />;
        }
    };

    setContentEdit = (channel) => {
        switch (channel) {
            case "sunco" :
                return <SuncoEdit/>;
            case "sunco_campaigns":
                return <SuncoCampaignsEdit />;
        }
    };

    setContentCreate = (channel) => {
        if (!this.props.location.pathname.includes("/edit") && channel !== "directory") {
            switch (channel) {
                case "sunco" :
                    return <SuncoCreate/>;
                case "sunco_campaigns":
                    return <SuncoCampaignsCreate />;
            }
        } else {
            const {location} = this.props;
            return <Redirect to={location.pathname.replace(`/${channel}`, "")}/>;
        }
    };

    render() {
        const {match} = this.props;
        return (
            <div className={"man-content"}>
                <Switch>
                    <Route path="/integrations/directory" exact>
                        <IntegrationsDirectory />
                    </Route>
                    <Route path="/integrations/:channel" exact>
                        {this.setContentView(match.params.channel)}
                    </Route>
                    <Route path="/integrations/:channel/edit/:id" exact>
                        {this.setContentEdit(match.params.channel, match.params.id)}
                    </Route>
                    <Route path="/integrations/:channel/create" exact>
                        {this.setContentCreate(match.params.channel)}
                    </Route>
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_route_integrations = connect(
    mapStateToProps
)(RouteIntegrations);

export default withRouter(connect_route_integrations);